export const SET_PICK_A_SEAT_BEST_AVAILABLE_WARNING =
    'setPickASeatBestAvailableWarning';
export const CLEAR_PICK_A_SEAT_BEST_AVAILABLE_WARNING =
    'clearPickASeatBestAvailableWarning';

export const ORDER_STATUS_POLLING_PERIOD_IN_MS = 1500;
export const ORDER_STATUS_POLLING_TIMEOUT_IN_MS = 5 * 60 * 1000; // 5 minutes
export const SLOW_ORDER_STATUS_POLLING_DURATION_IN_MS = 30 * 1000; // 30 seconds
export const STRIPE_STATUS_POLLING_TIMEOUT_IN_MS = 20 * 60 * 1000; // 20 minutes
export const STRIPE_STATUS_POLLING_LONG_PERIOD_IN_MS = 3000;
export const STRIPE_SLOW_ORDER_STATUS_POLLING_DURATION_IN_MS = 60 * 1000; // 1 minute
